/* eslint-disable no-unused-vars */
import React from "react";
import { useRoutes } from "react-router-dom";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { baseTheme } from './assets/global/Theme-variable';
import { Toaster } from 'react-hot-toast';
import './App.css';
import fetchRoute from "./routes/Router";
import { useSelector } from "react-redux";
import { useLanguage } from "./contexts/ThemeContext/ThemeContext";
import { useUserStatusCheck } from "./hooks/useUserStatusCheck";

import typography from "./assets/global/Typography";
import shadows from "./assets/global/Shadows";


const App = () => {
  const user = useSelector((state) => state?.user);
  const fetch = fetchRoute(user)
  const routing = useRoutes(fetch.role);
  const SidebarWidth = 265;
  const TopbarHeight = 70;

  // Check user status for automatic logout on deactivation
  useUserStatusCheck();



  const { locale } = useLanguage()
  const baseTheme = createTheme({
    typography: {
      // Applying Montserrat to all headings
      h1: { fontFamily: 'Montserrat, sans-serif' }, // Page titles
      h2: { fontFamily: 'Montserrat, sans-serif' },
      h3: { fontFamily: 'Montserrat, sans-serif' },
      p: { fontFamily: 'Montserrat, sans-serif' },
    },
    direction: "ltr",
    palette: {
      primary: {
        default: "#6ebe44",   //!empowercare green
        main: "#1a97f5",
        light: "#e6f4ff",
      },
      secondary: {
        main: "#1e4db7",
      },
      background: {
        default: "#EBE0D3",
      },
      success: {
        main: "#6ebe44",
        contrastText: "#ffffff",
      },
      danger: {
        main: "#fc4b6c",
      },
      error: {
        main: "#fc4b6c",
      },
      warning: {
        main: "#fdd43f",
        contrastText: "#ffffff",
      },
      text: {
        secondary: "#777e89",
        danger: "#fc4b6c",
      },
      sidenav: {
        main: "#6EBE44",
        dark: "#707070",
      },
    },
    shape: {
      borderRadius: 5,
    },

    components: {
      MuiCssBaseline: {
        styleOverrides: {
          "*": {
            boxSizing: "border-box",
          },
          html: {
            height: "100%",
            width: "100%",
          },
          body: {
            height: "100%",
            margin: 0,
            padding: 0,
          },
          "#root": {
            height: "100%",
          },
        },
      },
      MuiContainer: {
        styleOverrides: {
          root: {
            paddingLeft: "15px !important",
            paddingRight: "15px !important",
            maxWidth: "1600px",
          },
        },
      },

      MuiButton: {
        styleOverrides: {
          root: {
            textTransform: "none",
            boxShadow: "none",
            "&:hover": {
              boxShadow: "none",
            },
          },
        },
      },

      MuiListItem: {
        styleOverrides: {
          root: {
            borderRadius: "9px",
          },
        },
      },

      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: "20px",
            padding: "14px",
            margin: "0px 0px",
          },
        },
      },

      MuiListItemIcon: {
        styleOverrides: {
          root: {
            minWidth: "40px",
          },
        },
      },

      MuiGridItem: {
        styleOverrides: {
          root: {
            paddingTop: "30px",
            paddingLeft: "30px !important",
          },
        },
      },
    },
    mixins: {
      toolbar: {
        color: "#949db2",
        "@media(min-width:1280px)": {
          minHeight: TopbarHeight,
          padding: "0 30px",
        },
        "@media(max-width:1280px)": {
          minHeight: "64px",
        },
      },
    },
    status: {
      danger: "#e53e3e",
    },
    typography,
    shadows,
  }
    // , locales[locale],
  );

  return (
    <ThemeProvider theme={baseTheme}>
      <Toaster />

      {routing}
    </ThemeProvider>
  );
};

export default App;
